import {
    keyIssueUpdateConcepts,
    keyIssueClearConcepts,
    keyIssueAddMapping,
    keyIssueRemoveMapping
} from "../../../../actions/key-issue-actions"

import buildEditMappingsContainer from "../../../common/concept-mappings/build-edit-mappings-container"

export default buildEditMappingsContainer(
    "keyIssues",
    keyIssueUpdateConcepts,
    keyIssueClearConcepts,
    keyIssueAddMapping,
    keyIssueRemoveMapping
)
